import { render, staticRenderFns } from "./AktivaForm.vue?vue&type=template&id=3571815e&"
import script from "./AktivaForm.vue?vue&type=script&lang=js&"
export * from "./AktivaForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports